import {
    isEmailRule,
    isEmptyRule,
    isMinLengthRule,
    isNoSymbolsRule,
    isPhoneRule,
} from "./rules"
import { IContactUsValidations } from "./validationRule"

// validations object, give each field the rule you need

export const validations: IContactUsValidations = {
    first_name: [isEmptyRule, isMinLengthRule, isNoSymbolsRule],
    last_name: [isEmptyRule, isMinLengthRule, isNoSymbolsRule],
    email: [isEmptyRule, isEmailRule],
    title: [isEmptyRule, isMinLengthRule],
    message: [isEmptyRule, isMinLengthRule],
    phone: [isEmptyRule, isPhoneRule],
    calling_code: [isEmptyRule],
}
